import initHeroCarousel from '@sectionsJS/hero-carousel';
import initCategoryTwoSides from '@sectionsJS/category-two-sides';
import initCategoryImages from '@sectionsJS/category-images';
import initThreeSlides from '@sectionsJS/three-slides';
import initProductList from '@sectionsJS/product-list';
import adjustGridPromo from '@sectionsJS/grid-promo';
import instagramSection from '@sectionsJS/instagram';
import initEditorialPromo from '@sectionsJS/editorial-promo';
import initFeaturedReviews from '@sectionsJS/featured-reviews';

$(async () => {
  initHeroCarousel();
  initCategoryTwoSides();
  initCategoryImages();
  initThreeSlides();
  adjustGridPromo();
  instagramSection();  
  initProductList('shopify'); // The Nosto list are being initialized after their content get loaded and populated
  initFeaturedReviews();
});

// Needs Scrollmagic
$(window).on('load', async () => {
  initEditorialPromo();
});
